var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C10.9164 15 12.3747 15 13.3969 14.2573C13.7271 14.0174 14.0174 13.7271 14.2573 13.3969C15 12.3747 15 10.9164 15 8C15 5.08354 15 3.62531 14.2573 2.60305C14.0174 2.27291 13.7271 1.98257 13.3969 1.74271C12.3747 1 10.9164 1 8 1C5.08354 1 3.62531 1 2.60305 1.74271C2.27291 1.98257 1.98257 2.27291 1.74271 2.60305C1 3.62531 1 5.08354 1 8C1 10.9164 1 12.3747 1.74271 13.3969C1.98257 13.7271 2.27291 14.0174 2.60305 14.2573C3.62531 15 5.08354 15 8 15Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 4.11133V7.22244M11.8889 4.11133V11.8891M4.11108 4.11133V9.55577",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardActive);
export default __webpack_public_path__ + "static/media/card-active.80ee0d588d8051e4fb40d69f2624379b.svg";
export { ForwardRef as ReactComponent };